import { USER_LOGOUT } from "redux-store/auth/actions";
import { defaultArray, defaultObject } from "redux-store/selectors";

import {
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE,
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS,
  ACCOUNT_STATS_LOAD_BY_DATE_FAILURE,
  ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS,
  UNLOAD_ACCOUNT_STATS,
} from "./actions";

const initialState = {
  device_average_uptime: null,
  device_hibernating: null,
  device_online: null,
  device_total: null,
  events_24h: null,
  incidents: defaultArray,
  message: null,
  player_stats: defaultArray,
  sandbox_hibernating: null,
  sandbox_offline: null,
  sandbox_online: null,
  sandbox_total: null,
  statusCode: null,
  strategy_stats: defaultArray,
  uptimes_by_network: defaultObject,
};

function accountStatsReducer(state = initialState, action) {
  const { payload = {}, type } = action;
  const { response = {} } = payload;
  const { status: statusCode } = response;
  const { data: stats, message } = payload;

  switch (type) {
    case ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS:
    case ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS:
      return {
        ...state,
        ...stats,
        message,
        statusCode,
      };
    case ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE:
    case ACCOUNT_STATS_LOAD_BY_DATE_FAILURE:
      return {
        ...state,
        statusCode,
      };
    case UNLOAD_ACCOUNT_STATS:
    case USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export { accountStatsReducer };
